import type { FaireProductEntity } from "../../entity_types/product";

export const p_9sksmnwt7t: FaireProductEntity = {
  token: "p_9sksmnwt7t",
  type: "product",
  name: "Garden Quartz Lodolite Polished Crystal YOU CHOOSE #3",
  brandToken: "b_de8f5way8k",
  brandName: "Rock Paradise",
  imageUrl:
    "https://cdn.faire.com/fastly/9747eb606134697081374c55651e02dab814dac71157f131535eca7fd7a94a33.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4169bc84c4db6eec576a1bd4d98cae9ea6a9b3143c4fc7bca02872bf4d94ae1b.jpeg",
    "https://cdn.faire.com/fastly/9ff141670553590857b0efa79820766e9154aac03013ab5688054fd2737992df.jpeg",
    "https://cdn.faire.com/fastly/f2c576bd017a3e7d8e7f82baf3ca4e408223e63090093580f582de235afc69a4.jpeg",
    "https://cdn.faire.com/fastly/5fe5d0ce70b614d7fe368f7f4cee660496836979c3be1e91f8a006c60be05ba0.jpeg",
    "https://cdn.faire.com/fastly/ff218603ff1bb33f91ce38d2143e00e1515e13839cdcaddc5edebe67f361595a.jpeg",
  ],
  priceDollars: 33.26,
  description:
    'This listing is for the exact Garden Quartz lodolite polished crystal you choose. UP7-27\n\nAmplify your collection with this rare stone\n\nThese three lodolite polished prisms each feature unique, scenic inclusions with supreme clarity.\n\nLodolite: Lodolite, also known as Garden Quartz, is believed to enhance spiritual growth, promote deep emotional healing, and aid in visualization and manifestation practices.\n\nWhy you will love this Lodolite Crystal:\n\n * Incredible Design: The crystal is carved and is striking and unique, capable of catching anyone\'s attention. \n * Strengthening Energy: Lodolite is believed to strengthen your spiritual side and promote growth and healing. \n * Perfect Gift: Giving this stone to someone shows utmost care as there are many great and beneficial traits in this stone. \nProduct Details:\n\n * One of a Kind: You will receive the exact lodolite crystal you choose as pictured. \nVariants:\n\n * 1. 2.375" x 1.375" x 1" \n * 2. 2.125" x 1.375" x 1.75" \n * 3. 2.25" x 1.5" x 1.625" \nContent: Lodalite Crystal\n\nDisclaimer: this product is intended for decorative purposes only. For any health related questions, consult a healthcare professional. This information is not meant to diagnose, treat, cure, or prevent any disease.\n',
  tags: [],
  msrpDollars: 66.51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:09.705Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
